const SCROLLABLE_OVERFLOW_VALUES = ['auto', 'scroll', 'overlay'];
const RESIZE_STABLE_IDLE_MS = 100;

export function resolveVerticalScrollArea(element: HTMLElement): HTMLElement {
    let candidate: HTMLElement | null = element;
    while (candidate !== null && candidate !== document.body) {
        if (SCROLLABLE_OVERFLOW_VALUES.includes(window.getComputedStyle(candidate).overflowY)) {
            return candidate;
        }
        candidate = candidate.parentElement;
    }
    return element;
}

export function alignElementBottomWithin(scrollArea: HTMLElement, element: HTMLElement, bottomGap: number) {
    const scrollAreaRect = scrollArea.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    scrollArea.scrollTop += elementRect.bottom - scrollAreaRect.bottom + bottomGap;
}

export function trackResizeUntilStable(
    element: HTMLElement,
    onResize: () => void,
): () => void {
    if (typeof ResizeObserver === 'undefined') {
        return () => {};
    }

    let timeoutId = 0;
    let isTracking = true;
    let observer: ResizeObserver;
    const stop = () => {
        if (!isTracking) {
            return;
        }
        isTracking = false;
        window.clearTimeout(timeoutId);
        observer.disconnect();
    };
    const scheduleStop = () => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(stop, RESIZE_STABLE_IDLE_MS);
    };
    observer = new ResizeObserver(() => {
        onResize();
        scheduleStop();
    });
    observer.observe(element);
    scheduleStop();
    return stop;
}
